import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { TableCell, TableRow } from '@/common/ui/table'
import { Row } from '@tanstack/react-table'
import { GetBankAccountDataResponse } from '@/modules/bank/type'
import { flexRender } from '@tanstack/react-table'

interface SortableRowProps {
	row: Row<GetBankAccountDataResponse>
}

export function SortableRow({ row }: SortableRowProps) {
	const {
		attributes,
		listeners,
		transform,
		transition,
		setNodeRef,
		isDragging,
	} = useSortable({
		id: row.original.id,
	})

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
	}

	return (
		<TableRow
			ref={setNodeRef}
			style={style}
			className={isDragging ? 'opacity-50' : ''}
			{...attributes}
			{...listeners}
		>
			{row.getVisibleCells().map((cell) => (
				<TableCell key={cell.id}>
					{flexRender(cell.column.columnDef.cell, cell.getContext())}
				</TableCell>
			))}
		</TableRow>
	)
}
